<template lang="pug">
  div(v-if='forRemoval')
    div.modal-content
      p.title.medium Remove Account
      .vspace.small
      p(v-if='account') Are you sure you want to remove 
        span.blue-text {{account.email}}?
      p This cannot be undone.
    
    div.modal-footer.right-align
      a.waves-effect.btn.red(@click='onRemove(mutableAccount)') Remove
      a.waves-effect.btn-flat(@click='onCancel') Cancel
  div(v-else)
    div.modal-content
      p.title.medium(v-if='isNewAccount') New Account
      p.title.medium(v-else) Edit Account
      .vspace.small
      .row
        .col.s12.m6.input-field
            input#email.form-control.validate(v-model='mutableAccount.email', type='email', required)
            label.active(for='email') Email
        .col.s12.m6.input-field
            input#username.form-control.validate(v-model='mutableAccount.username', type='text', required :readonly='!isNewAccount')
            label.active(for='username') Username
        .col.s12.m6.input-field
            input#firstName.form-control.validate(v-model='mutableAccount.firstName', type='text', required)
            label.active(for='firstName') First Name
        .col.s12.m6.input-field
            input#lastName.form-control.validate(v-model='mutableAccount.lastName', type='text', required)
            label.active(for='lastName') Last Name
      
    div.modal-footer.right-align
      a.waves-effect.btn.indigo(@click='onSave(mutableAccount, isNewAccount)') Save
      a.waves-effect.btn-flat(@click='onCancel') Cancel
</template>
<script>
export default {
  props: ['account', 'isNewAccount', 'onSave', 'onCancel', 'forRemoval', 'onRemove'],
  data () {
    return {
      mutableAccount: {
        uid: null,
        email: null,
        username: null,
        firstName: null,
        lastName: null
      }
    }
  },
  mounted () {
    const account = this.account || {}
    this.mutableAccount.uid = account.uid
    this.mutableAccount.email = account.email
    this.mutableAccount.firstName = account.firstName
    this.mutableAccount.lastName = account.lastName
    this.mutableAccount.username = account.localMembership.username
  }
}
</script>



// WEBPACK FOOTER //
// src/components/app-account-details.vue